import React from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function ActionCard({ to, label, icon: Icon, accent, badge, className }) {
  return (
    <Link
      to={to}
      className={["fancy-action-card", className].filter(Boolean).join(" ")}
      style={accent ? { borderColor: accent } : {}}
    >
      {Icon && (
        <span className="action-icon" style={accent ? { color: accent } : {}}>
          <Icon />
        </span>
      )}
      <span className="action-label">{label}</span>
      <AnimatePresence>
        {badge ? (
          <motion.span
            className="nav-badge"
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.7, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            key={badge}
          >
            {badge}
          </motion.span>
        ) : null}
      </AnimatePresence>
    </Link>
  );
}
